import BackgroundGroup from '../../assets/BackgroundGroup.svg';
import ButtonLoad from '../../assets/ButtonLoad.svg';
import Loader from '../../assets/loader.png';
import './Loader.css';

const LoaderPro = () => {
  return (
    <div className="Loading">
      <div className="backgroundGroup">
        <img alt="" src={BackgroundGroup} />
      </div>
      <img alt="" className="buttonLoad" src={ButtonLoad} />
      <div className="loadingImg">
        <img alt="" style={{ width: '100%', height: '100%' }} src={Loader} />
      </div>
    </div>
  );
};

export default LoaderPro;
